<div class="root-wrapper" *ngIf="train; else noTrain">
  <div class="actions-wrapper">
    <qm-element-actions
      *ngIf="currentFeature.id === train?._id"
      [selectedFeature]="currentFeature"
      [selectedLayer]="currentFeature.layer"
      [visibleButtons]="{info: false, flag: true, focus: true}">
    </qm-element-actions>
  </div>
  <nav ngbNav #nav="ngbNav" class="nav-tabs" [activeId]="openTab">

    <ng-container ngbNavItem="schedule">
      <a ngbNavLink>
        {{'Timetable' | translate}}
      </a>
      <ng-template ngbNavContent>
        <qm-train-schedule [train]="train"></qm-train-schedule>
      </ng-template>
    </ng-container>

    <ng-container ngbNavItem="cargomanifest" *ngIf="train && train.type === 'FREIGHT' && hasPermission('cargo-manifest')">
      <a ngbNavLink>
        {{'Cargo' | translate}}
      </a>
      <ng-template ngbNavContent>
        <qm-vrgroup-cargo-manifest [train]="train"></qm-vrgroup-cargo-manifest>
      </ng-template>
    </ng-container>

    <ng-container ngbNavItem="dependencies" *qmAuth="'equipment-rotation'">
      <a ngbNavLink>
        <ng-container *ngIf="trainConflictAlarms.length">
          <i class="fal fa-exclamation-triangle exclamation-icon"></i>
        </ng-container>
        {{'Stock' | translate}}
      </a>
      <ng-template ngbNavContent>
        <qm-vrgroup-train-dependencies [train]="train"></qm-vrgroup-train-dependencies>
      </ng-template>
    </ng-container>

    <ng-container ngbNavItem="personel" *qmAuth="'personnel-rotation'">
      <a ngbNavLink>
        <ng-container *ngIf="shiftConflictAlarms.length">
          <i class="fal fa-exclamation-triangle exclamation-icon"></i>
        </ng-container>
        {{'Personnel' | translate}}
      </a>
      <ng-template ngbNavContent>
        <qm-timeline-chart [train]="train" [shiftConflictAlarms]='shiftConflictAlarms'></qm-timeline-chart>
      </ng-template>
    </ng-container>

    <ng-container ngbNavItem="info">
      <a ngbNavLink>
        {{'Info' | translate}}
      </a>
      <ng-template ngbNavContent>
        <qm-vrgroup-train-details [train]="train"></qm-vrgroup-train-details>
      </ng-template>
    </ng-container>

    <!--
    <ng-container ngbNavItem="composition">
      <a ngbNavLink>
        {{'Composition' | translate}}
      </a>
      <ng-template ngbNavContent>
        <qm-vrgroup-train-compositions [train]="train"></qm-vrgroup-train-compositions>
      </ng-template>
    </ng-container>
    -->

    <ng-container ngbNavItem="timeline">
      <a ngbNavLink>
        {{'Timeline' | translate}}
      </a>
      <ng-template ngbNavContent>
        <qm-element-timeline [currentFeature]="currentFeature"></qm-element-timeline>
      </ng-template>
    </ng-container>

  </nav>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
<ng-template #noTrain>
  {{"This train doesn't run on the selected day." | translate}}
</ng-template>

<ng-template #titleTemplate>
  <ng-container *ngIf="train; else titleNoTrain">
    <ng-container *ngIf="$any(train).label; else noLabel">{{$any(train).label}}</ng-container>
    <ng-template #noLabel>{{train.category}} {{train.tripNumber}} {{train.depStation}} - {{train.arrStation}}</ng-template>
  </ng-container>
  <ng-template #titleNoTrain>
    {{tripNumber}} ({{"doesn't run" | translate}})
  </ng-template>
  <!-- need to stop mousedown because otherwise the draggable title bar cancels the click -->
  <div *ngIf="date" class="title-date-picker" (mousedown)="$event.stopPropagation()">
    <input
      type="hidden"
      ngbDatepicker
      [markDisabled]="datepickerDateDisabled"
      outsideDays="collapsed"
      #datePicker="ngbDatepicker"
      [ngModel]="date"
      (click)="datePicker.toggle()"
      (dateSelect)="changeDate($event)"
      class="form-control-plaintext form-control-sm"
      readonly
    >
    <a href="#" (click)="$event.preventDefault(); datePicker.toggle()" class="date-link">
      {{date.day}}.{{date.month}}.{{date.year}}&nbsp;&#9660; <!-- triangle pointing down -->
    </a>
  </div>
</ng-template>
